// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class conditionClauseDtoList extends ItiBaseDto {
	public conditionClauseId: number;
	public clauseId: number;
	public clauseLang: string;
	public clauseName: string;
	public clauseDescription: string;
	public clauseText: string;
	public accepted: boolean;

	constructor(src?: any) {
		super(src);

		this.accepted = false;

		Object.assign(this, src);
	}
}
